<form *ngIf="operatorSelectorForm" [formGroup]="operatorSelectorForm" class="flex-row">
    <app-select-searching-dynamic-input class="m-0 p-0 text-secondary-darker" [leftIcon]='"support_agent"'
        [defaultValue]="actualOperator?.id?.toString() ?? null"
        [elements]="operatorsOnSelect ?? []"
        (selectedWithEntity)="onUpdateOperator($event)"
        [name]="this.OPERATORS"
        [nameSearching]="this.OPERATORS_SEARCHING" [form]="this.operatorSelectorForm"
        [placeholder]="('modules.cases.operators-selector.placeholders.select-operator' | exp:'':'Operador/a del caso')" [calculateId]="this.calculateId" [calculateName]="this.calculateName"
        [placeholderNoValue]="('modules.cases.operators-selector.placeholders.no-value' | exp:'':'Sin resultados')" [placeholderSearching]="('modules.cases.operators-selector.placeholders.searching-operator' | exp:'':'Buscar operador...')"
        [httpGet]="this.getOperatorsByNameAndSurname">
    </app-select-searching-dynamic-input>
</form>
